export default __webpack_public_path__ + "static/media/bingeworthy.934d795a.png";